"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ERROR_REASONS = {
    NOT_AUTHENTICATED: "not-authenticated",
    NOT_AUTHORIZED: "not-authorized",
    MISSING_TOKEN: "missing-token",
    UNKNOWN: "unknown"
};

exports.ERROR_REASONS = ERROR_REASONS;
var EVENT_PREFIX = "ergauth";

exports.EVENT_PREFIX = EVENT_PREFIX;
var EVENTS = {
    REFRESH: EVENT_PREFIX + ":refresh",
    POPUP_CLOSED: EVENT_PREFIX + ":popupClosed"
};
exports.EVENTS = EVENTS;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-auth/dist/constants.js
 ** module id = 776
 ** module chunks = 0
 **/